// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/DevelopmentStrategies.tsx

import HeroParallax from "../../components/HeroParallax.tsx";
import Counter from "../../components/Counter.tsx";
import Showcase from "../../components/Showcase.tsx";
import PartnerGrid from "../../components/PartnerGrid.tsx";
import CareersBanner from "../../components/CareersBanner.tsx";
import ESG from "../../components/ContentCard.tsx";
import ContactPerson from "../../components/ContactPerson.tsx";
import AnchorMenu from "../../components/AnchorMenu.tsx";
import { useLanguage } from "../../lang/index.lang.tsx";

const DevelopmentStrategies = () => {
  const { t } = useLanguage();

  return (
    <>
      <AnchorMenu
        title={t("services.development-strategies.title")}
        titleLink="#services"
        items={[      
          { id: "Title", label: t("counter.heading.title"), anchor: "Counter" },    
          { id: "2", label: t("anchor.whatWeDo"), anchor: "AllServices" },          
          { id: "3", label: t("navigation.career"), anchor: "Careers" },
          { id: "4", label: t("services.heading.partner"), anchor: "Partner" },     
          { id: "5", label: t("anchor.contactPersons"), anchor: "ContactPersons" },
          { id: "6", label: t("home.esg.heading.subtitle"), anchor: "esg" },    
          
        ]}
      />

      

      <section id="Services">
      <HeroParallax        
        header={t("services.development-strategies.header")}
        welcome={t("services.development-strategies.welcome")}
        title={t("services.development-strategies.description.short")}
        description={t("services.development-strategies.description.long")}
        buttonText={t("common.learnMore")}
        buttonLink=""
        image="/images/EST-767664.jpg"
      />
    </section>

      <section id="Counter">
      <Counter 
        items={[
          {
            key: "buildingPeriod",
            endValue: 30,
            prefix: "-",
            suffix: "%",
          },
          {
            key: "buildingVolume",
            endValue: 100,
            prefix: "",
            suffix: " Mio.€",
          },
          {
            key: "realizedProjects",
            endValue: 200,
            prefix: "",
            suffix: "+",
          },
          {
            key: "realizedSquareMeters",
            endValue: 75000,
            prefix: "",
            suffix: "+",
          },
        ]}
        sectionTitle={t("services.development-strategies.title")}
        mainTitle={t("counter.heading.title")}
      />
      </section>

      

      <section id="AllServices">
        <Showcase
          heading={{
            subtitle: t("services.development-strategies.title"),
            title: t("services.development-strategies.header"),
            explore: t("services.development-strategies.explore"),
          }}        
          items={[   
            {
              id: 1,
              title: t("services.feasibility-studies.title"),
              subtitle: t("services.feasibility-studies.description.short"),
              description: t("services.feasibility-studies.description.long"),
              link: "",
            },         
            {
              id: 2,
              title: t("services.vertical-development.title"),
              subtitle: t("services.vertical-development.description.short"),
              description: t("services.vertical-development.description.long"),
              link: "",
            },            
            {
              id: 3,
              title: t("services.authority-coordination.title"),
              subtitle: t("services.authority-coordination.description.short"),
              description: t("services.authority-coordination.description.long"),
              link: "",
            },
            {
              id: 4,
              title: t("services.energy-advisory.title"),
              subtitle: t("services.energy-advisory.description.short"),
              description: t("services.energy-advisory.description.long"),
              link: "/services/energy-advisory",
            },            
            {
              id: 8,
              title: t("services.fire-protection.title"),
              subtitle: t("services.fire-protection.description.short"),
              description: t("services.fire-protection.description.long"),
              link: "/services/fire-protection",
            },
          ]}        
          learnMoreText={t("services.heading.learnMore")}
        />
      </section>

      <section id="Careers">
        <CareersBanner
          image="/images/EST-6372937.jpg"
          title={t("home.heroBanner.title")}
          description={t("home.heroBanner.description")}
          buttonText={t("home.heroBanner.buttonText")}
          buttonLink="/careers"
        />
      </section>

      <section id="Partner">
        <PartnerGrid />
      </section>

      <section id="ContactPersons">
        <ContactPerson
          heading={{
            subtitle: t("services.development-strategies.department"),
            title: t("services.heading.contact-person"),
          }}
          employeeIds={["AS"]}
        />
      </section>

      <section id="esg">
        <ESG
          heading={{
            title: t("home.esg.heading.title"),    
            description: t("home.esg.heading.description"),       
          }}
          data={[
            {
              id: 1,
              title: t("home.esg.s.title"),
              description: t("home.esg.s.description"),
              image: "/images/EST-1385648186.jpg",
              category: t("home.esg.s.category"),
              buttonText: t("home.esg.s.buttonText"),
              buttonLink: "/about",
            },
            {
              id: 2,
              title: t("home.esg.e.title"),
              description: t("home.esg.e.description"),
              image: "/images/EST-599972772.jpg",
              category: t("home.esg.e.category"),
              buttonText: t("home.esg.e.buttonText"),
              buttonLink: "/about",
            },          
            {
              id: 3,
              title: t("home.esg.g.title"),
              description: t("home.esg.g.description"),
              image: "/images/EST-12499784456.jpg",
              category: t("home.esg.g.category"),
              buttonText: t("home.esg.g.buttonText"),
              buttonLink: "/about",
            },          
          ]}
        />
      </section>

      
    </>
  );
};

export default DevelopmentStrategies;
